import { toastError } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import * as actionTypes from '@store/favourite/action-types';

import ApiClient from '@lib/apiClient';

export const fetchTotalLikeCount =
	(type = 'TOTAL_COUNT') =>
	async (dispatch) => {
		try {
			if (type === 'RESET') {
				dispatch({
					type: actionTypes.TOTAL_FAVOURITE_UNSEEN_COUNT,
					payload: 0
				});
			} else {
				const response = await ApiClient.GET('favouriteUnseenCountApi');
				dispatch({
					type: actionTypes.TOTAL_FAVOURITE_UNSEEN_COUNT,
					payload: response.data
				});
			}
		} catch (error) {
			dispatch({ type: actionTypes.TOTAL_LIKED_PRODUCT_FAILURE });
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

export const fetchFavouriteProducts =
	(
		page = 0,
		size = 30,
		search = '',
		sortingOption,
		folderId,
		isDrafted = false,
		filterParams,
		isListView = false,
		setCurrentScrolledProduct = () => {}
	) =>
	async (dispatch) => {
		dispatch(openLoader());
		try {
			let params = `?page=${page}&size=${size}`;

			let requestBody = { page, size, sortingOption, search, folderId, isDrafted, isListView };
			if (filterParams) {
				requestBody = { ...requestBody, ...filterParams };
			}
			const response = await ApiClient.POST('getFavouriteProducts', requestBody, params);
			setCurrentScrolledProduct(response.data.data.map((item) => item?.productResponse?.id));
			const organizeResponse = response.data.data.map((item) => {
				if (item?.productResponse?.isSet) {
					return {
						...item,
						productResponse: {
							...item.productResponse,
							sampleInventoryItemResponseList: item.productResponse.setMemberProducts.flatMap(
								(member) => member.sampleInventoryItemResponseList || []
							)
						}
					};
				}
				return item;
			});

			dispatch({
				type:
					page > 0
						? actionTypes.FETCH_FAVOURITE_PRODUCT_LIST_MORE_SUCCESS
						: actionTypes.FETCH_FAVOURITE_PRODUCT_LIST_SUCCESS,
				payload: {
					...response.data,
					data: organizeResponse
				}
			});
		} catch (error) {
			dispatch(closeLoader());
			dispatch({ type: actionTypes.FETCH_FAVOURITE_PRODUCT_LIST_FAILURE });
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		} finally {
			dispatch(closeLoader());
		}
	};

export const fetchFavouriteMaterials =
	(page = 0, size = 30, search = '') =>
	async (dispatch) => {
		try {
			let params = `?page=${page}&size=${size}&search=${search}`;
			const response = await ApiClient.GET('getFavouriteMaterials', params);
			dispatch({
				type:
					page > 0
						? actionTypes.FETCH_FAVOURITE_MATERIAL_LIST_MORE_SUCCESS
						: actionTypes.FETCH_FAVOURITE_MATERIAL_LIST_SUCCESS,
				payload: response.data
			});
		} catch (error) {
			dispatch({ type: actionTypes.FETCH_FAVOURITE_MATERIAL_LIST_FAILURE });
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

export const fetchFavouriteFolders =
	(page = 0, size = 20, sort = 'NEWEST') =>
	async (dispatch) => {
		try {
			let params = `?page=${page}&size=${size}&sortB=${sort}`;
			const response = await ApiClient.GET('getFavouriteFolders', params);
			dispatch({
				type:
					page > 0
						? actionTypes.FETCH_FAVOURITE_FOLDER_LIST_MORE_SUCCESS
						: actionTypes.FETCH_FAVOURITE_FOLDER_LIST_SUCCESS,
				payload: response.data
			});
		} catch (error) {
			dispatch({ type: actionTypes.FETCH_FAVOURITE_FOLDER_LIST_FAILURE });
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

export const setActiveFavouritePageTab = (payload) => ({
	type: actionTypes.SET_ACTIVE_FAVOURITE_PAGE_TAB,
	payload
});
